export const CHAT_CONVERSATIONS_CHANGED = 'couplespace:chat-conversations-changed';

export function notifyChatConversationsChanged(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CHAT_CONVERSATIONS_CHANGED));
  }
}
